<template>
  <div>
    <vue-chart type="bar" :data="chartData" :options="options"></vue-chart>
  </div>
</template>

<script>
export default {
  props: ["datasets", "maxvalue"],
  data() {
    return {
      chartData: {
        labels: ["Q1", "Q2", "Q3", "Q4"],
        datasets: [],
      },
      options: {
        tooltips: {
          displayColors: false,
          bodySpacing: 0,
          xPadding: 12,
          yPadding: 12,
          cornerRadius: 0,
          bodyFontSize: 15,
          bodyFontFamily: "DIN Pro, sans-serif",
          callbacks: {
            mode: "x",
            title: () => {},
            label: (tooltipItem, chartData) => {
              var label =
                chartData.datasets[tooltipItem.datasetIndex].label || "";

              if (label) {
                label += ": ";
              }

              label += tooltipItem.yLabel;
              return label;
            },
          },
        },
        scales: {
          xAxes: [
            {
              barThickness: 50,
              stacked: true,
              gridLines: {
                display: false,
              },
              ticks: {
                fontFamily: "DIN Pro, sans-serif",
                fontSize: 15,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                max: this.maxvalue,
                stepSize: 2000,
                fontFamily: "DIN Pro, sans-serif",
                fontSize: 15,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
      },
    };
  },
  mounted() {
    this.datasets.forEach((item) => {
      this.chartData.datasets.push({
        label: item.label, // Sector
        backgroundColor: item.background_color, // Color
        data: item.data.split(",").map((x) => {
          return parseInt(x);
        }), // Quarters
      });
    });
  },
};
</script>
